import { authContext } from 'contexts/AuthContext'
import { useState, useEffect, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { useLocalStorage } from './useLocalStorage'

export const useAdmin = () => {
  const location = useLocation()
  const [isAdmin, setIsAdmin] = useLocalStorage('isAdmin')
  const [isAllowed, setIsAllowed] = useLocalStorage('isAllowed')
  const [permissions, setPermission] = useState([])

  const { auth } = useContext(authContext)

  const checkIsAdmin = (res) => {
    let baseURL = location.pathname.split('/').slice(0, 3).toString().replaceAll(',', '/')

    let allowedURLs = []
    let permissionsTab = []

    if (
      res?.permissions?.includes(1) ||
      res?.permissions?.includes(2) ||
      res?.permissions?.includes(3) ||
      res?.permissions?.includes(4) ||
      res?.permissions?.includes(13) ||
      res?.permissions?.includes(14) ||
      res?.permissions?.includes(15)
    ) {
      permissionsTab.push('Company Management')
      allowedURLs.push('/app/company-management')
      permissionsTab.push('Management Centre')
      allowedURLs.push('/app/management-centre')
    }

    if (res?.permissions?.includes(5) || res?.permissions?.includes(6)) {
      permissionsTab.push('Staff Management')
      allowedURLs.push('/app/staff-management')
      permissionsTab.push('Management Centre')
      allowedURLs.push('/app/management-centre')
    }

    if (
      res?.permissions?.includes(7) ||
      res?.permissions?.includes(8) ||
      res?.permissions?.includes(9)
    ) {
      permissionsTab.push('Payroll Management')
      allowedURLs.push('/app/payroll')
      permissionsTab.push('Payroll')
      allowedURLs.push('/payroll')
      permissionsTab.push('Payroll History')
      allowedURLs.push('/payroll-history')
      permissionsTab.push('Yearly Report')
      allowedURLs.push('/yearly-report')
    }

    if (res?.permissions?.includes(18)) {
      permissionsTab.push('Talent Centre')
      allowedURLs.push('/app/recruitment')
      permissionsTab.push('Applicant Tracking')
      allowedURLs.push('/applicant-tracking')
      permissionsTab.push('Talent Upload')
      allowedURLs.push('/external-talent')
      permissionsTab.push('Recruiter Calendar')
      allowedURLs.push('/recruiter-calendar')
    }

    if (res?.permissions?.includes(10)) {
      permissionsTab.push('Performance Centre')
      allowedURLs.push('/app/appraisal-cycle')
      permissionsTab.push('Appraisal')
      allowedURLs.push('/app/appraisal-cycle')
      permissionsTab.push('Work Personality Fit')
      allowedURLs.push('/work-personality-fit-analysis')
    }

    if (res?.permissions?.includes(11)) {
      permissionsTab.push('Approval Centre')
      allowedURLs.push('/app/approval-center')
      permissionsTab.push('Leave')
      allowedURLs.push('/leave')
      permissionsTab.push('Claim')
      allowedURLs.push('/claim')
    }

    if (res?.permissions?.includes(12)) {
      permissionsTab.push('Approval Centre')
      allowedURLs.push('/app/approval-center')
      permissionsTab.push('Reimbursement')
      allowedURLs.push('/reimbursement')
    }

    if (res?.permissions?.includes(17)) {
      permissionsTab.push('Performance')
      allowedURLs.push('/app/performance')
    }

    // ASK backend for permission ID
    if (res?.permissions?.includes(17)) {
      permissionsTab.push('Staff Retention')
      allowedURLs.push('/app/staff-retention')
      permissionsTab.push('Overview')
      allowedURLs.push('/app/staff-retention')
      permissionsTab.push('Demographics')
      allowedURLs.push('/demographics')
      permissionsTab.push('Predicted Attrition')
      allowedURLs.push('/predicted-attrition')
    }

    if (res?.permissions?.includes(20)) {
      permissionsTab.push('Attendance Tracking')
      allowedURLs.push('/app/attendance-records')
    }
    if (res?.permissions?.includes(21)) {
      permissionsTab.push('Announcements')
      allowedURLs.push('/app/announcements')
    }

    setIsAdmin(Boolean(res?.permissions?.length))
    setPermission(permissionsTab)
    setIsAllowed(allowedURLs?.includes(baseURL))
  }

  useEffect(() => {
    checkIsAdmin(auth?.data)
  }, [auth]) // eslint-disable-line react-hooks/exhaustive-deps

  return [isAdmin, permissions, isAllowed]
}
